import React from 'react'
import { Cards, LeftCards, RightCards, UniqueTitle, UniqueOffering, RedBox1, RedBox2 } from './StyledComponents'
import Card from '../../../components/Card'
import { uniqueOfferingData } from '../../../data/websiteData'
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';

const UniqueOfferings = () => {
    const everyOdd = [];
    const everyEven = [];
    for (var i = 0; i < uniqueOfferingData.cardItems.length; i++) {
        if (i % 2 === 0) { // index is even
            everyOdd.push(uniqueOfferingData.cardItems[i]);
        }
        else {
            everyEven.push(uniqueOfferingData.cardItems[i]);
        }
    }
    return (
        <UniqueOffering>
            <RedBox2></RedBox2>
            <RedBox1></RedBox1>
            <Fade bottom cascade duration={1000}>
                <UniqueTitle>{uniqueOfferingData.title}
                    <span style={{ color: 'rgb(227, 44, 94)' }}>Qberaa</span>
                </UniqueTitle>
            </Fade>
            <Cards>
            <Fade bottom cascade duration={1000}>
                    <LeftCards>
                        {everyOdd.map((item, index) => (
                            <Card svgonToporBottom={item.aligSvgTopOrBottom}
                                alignSvgLeftorRight={item.aligSvgLeftorRight}
                                svgIconName={item.svgIcon}
                                text={item.text}
                                highlightText={item.highlightText}
                            ></Card>
                        ))}
                    </LeftCards>
                </Fade>
                <Fade bottom cascade duration={1000}>
                    <RightCards>
                        {everyEven.map((item, index) => (
                            <Card svgonToporBottom={item.aligSvgTopOrBottom}
                                alignSvgLeftorRight={item.aligSvgLeftorRight}
                                svgIconName={item.svgIcon}
                                text={item.text}
                                highlightText={item.highlightText}
                            ></Card>
                        ))}
                    </RightCards>
                </Fade>
            </Cards>
        </UniqueOffering>
    )
}

export default UniqueOfferings
